import { createSvgIcon } from '@mui/material'

export const PowerLeftIcon = createSvgIcon(
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M19 12.5L19 11.5L17.15 11.5L13.65 8L9 8L9 16L13.65 16L17.15 12.5L19 12.5ZM21 14.5L18 14.5L14.5 18L9 18C8.45 18 7.97917 17.8042 7.5875 17.4125C7.19583 17.0208 7 16.55 7 16L7 15L8 16L3 16L3 14L7 14L7 10L3 10L3 8L8 8L7 9L7 8C7 7.45 7.19583 6.97917 7.5875 6.5875C7.97917 6.19583 8.45 6 9 6L14.5 6L18 9.5L21 9.5L21 14.5Z'
      fill='currentColor'
    />
  </svg>,
  'PowerLeftIcon',
)
